// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"da32e15e","152":"e70cac4d","220":"2cf6baba","431":"4aa28057","489":"91611af0","608":"b9b19f32","787":"02b7fba6"}[chunkId] + ".chunk.js";
};